import React, { useState } from "react";
import { Col, Container, Row, Modal, Button } from "react-bootstrap";
import SectionSubHeader from "../sectionSubHeader";
import SectionHeader from "../sectionHeader";

const TempCareerCard = () => {
  const [activeModal, setActiveModal] = useState(null);

  const handleShow = (index) => setActiveModal(index);
  const handleClose = () => setActiveModal(null);

  return (
    <div className="section-bg open-position" id="open-position">
      <Container className="">
        <SectionHeader mainText1="OPEN POSITIONS" />
        <Row className="mb-50">
          <Col lg={8}>
            <SectionSubHeader headerText="Current Job Openings" />
          </Col>
          <Col lg={4}>
            <p>
              Exciting career growth, innovation, & impact. Explore
              opportunities today!
            </p>
          </Col>
        </Row>

        {/* Job 1 */}
        {/* <Row className="jobs">
          <Col lg={4}>
            <p className="posted-date">
              <img src="images/calendar.svg" alt="Diversity and Inclusion" />
              <span>Job Posted on May 5, 2025</span>
            </p>
            <h3>Software Developers/SAP Developer– Multiple Openings</h3>
          </Col>
          <Col lg={4} className="pt-30">
            <p>
              <img src="images/time.svg" alt="Full Time" />
              <span>Full Time</span>
            </p>
            <p>
              <img src="images/location.svg" alt="Full Time" />
              <span>Schaumburg, IL </span>
            </p>
          </Col>
          <Col lg={4} className="pt-20">
           <p className="posted-date text-end">
              <img style={{position: "relative", left: "-6px" }} className="mr-1" src="images/calendar.svg" alt="Diversity and Inclusion" />
              <span className="ml-1">Job Closed  on May 25, 2025</span>
            </p>
            <a href="javascript:void(0)" onClick={() => handleShow(1)}>
              View More
              <span>
                <img src="images/theme-arrow.svg" alt="Apply on LinkedIn" />
              </span>
            </a>
          </Col>
        </Row> */}

        {/* Job 2 */}
        {/* <Row className="jobs">
          <Col lg={4}>
            <p>
              <img src="images/calendar.svg" alt="Diversity and Inclusion" />
              <span>Posted on May 5, 2025</span>
            </p>
            <h3>
              Computer Systems Analyst/Business System Analyst– Multiple
              Openings
            </h3>
          </Col>
          <Col lg={4} className="pt-30">
            <p>
              <img src="images/time.svg" alt="Full Time" />
              <span>Full Time</span>
            </p>
            <p>
              <img src="images/location.svg" alt="Full Time" />
              <span>Schaumburg, IL</span>
            </p>
          </Col>
          <Col lg={4} className="pt-20">
           <p className="posted-date text-end">
              <img style={{position: "relative", left: "-6px" }} className="mr-1" src="images/calendar.svg" alt="Diversity and Inclusion" />
              <span className="ml-1">Job Closed  on May 25, 2025</span>
            </p>
            <a href="javascript:void(0)" onClick={() => handleShow(2)}>
              View More
              <span>
                <img src="images/theme-arrow.svg" alt="Apply on LinkedIn" />
              </span>
            </a>
          </Col>
        </Row> */}

        {/* Job 3 */}
        {/* <Row className="jobs">
          <Col lg={4}>
            <p>
              <img src="images/calendar.svg" alt="Diversity and Inclusion" />
              <span>Posted on May 5, 2025</span>
            </p>
            <h3>Software Developers– Multiple Openings</h3>
          </Col>
          <Col lg={4} className="pt-30">
            <p>
              <img src="images/time.svg" alt="Full Time" />
              <span>Full Time</span>
            </p>
            <p>
              <img src="images/location.svg" alt="Full Time" />
              <span>Schaumburg, IL</span>
            </p>
          </Col>
          <Col lg={4} className="pt-20">
           <p className="posted-date text-end">
              <img style={{position: "relative", left: "-6px" }} className="mr-1" src="images/calendar.svg" alt="Diversity and Inclusion" />
              <span className="ml-1">Job Closed  on May 25, 2025</span>
            </p>
            <a href="javascript:void(0)" onClick={() => handleShow(3)}>
              View More
              <span>
                <img src="images/theme-arrow.svg" alt="Apply on LinkedIn" />
              </span>
            </a>
          </Col>
        </Row> */}

        {/* <Row className="jobs">
          <Col lg={4}>
            <p className="posted-date">
              <img src="images/calendar.svg" alt="Diversity and Inclusion" />
              <span>Job Posted on May 5, 2025</span>
            </p>
            <h3>Software Developers– Multiple Openings – Schaumburg, IL</h3>
          </Col>
          <Col lg={4} className="pt-30">
            <p>
              <img src="images/time.svg" alt="Full Time" />
              <span>Full Time</span>
            </p>
            <p>
              <img src="images/location.svg" alt="Full Time" />
              <span>Schaumburg, IL </span>
            </p>
          </Col>
          <Col lg={4} className="pt-20">
            <p className="posted-date text-end">
              <img
                style={{ position: "relative", left: "-6px" }}
                className="mr-1"
                src="images/calendar.svg"
                alt="Diversity and Inclusion"
              />
              <span className="ml-1">Job Closed on May 25, 2025</span>
            </p>
            <a href="javascript:void(0)" onClick={() => handleShow(1)}>
              View More
              <span>
                <img src="images/theme-arrow.svg" alt="Apply on LinkedIn" />
              </span>
            </a>
          </Col>
        </Row> */}

        {/* Job 4 */}
        <Row className="jobs mt-4">
          <Col lg={4}>
            <p className="posted-date">
              <img src="images/calendar.svg" alt="Diversity and Inclusion" />
              <span>Job Posted on June 27, 2026</span>
            </p>
            <h3>Computer Systems Analysts – Multiple Openings - Schaumburg, IL</h3>
          </Col>
          <Col lg={4} className="pt-30">
            <p>
              <img src="images/time.svg" alt="Full Time" />
              <span>Full Time</span>
            </p>
            <p>
              <img src="images/location.svg" alt="Full Time" />
              <span>Schaumburg, IL</span>
            </p>
          </Col>
          <Col lg={4} className="pt-20">
            <p className="posted-date text-end">
              {/* <img
                style={{ position: "relative", left: "-6px" }}
                className="mr-1"
                src="images/calendar.svg"
                alt="Diversity and Inclusion"
              /> */}
              {/* <span className="ml-1">Job Closed on November 7, 2026</span> */}
            </p>
            <a href="javascript:void(0)" onClick={() => handleShow(4)}>
              View More
              <span>
                <img src="images/theme-arrow.svg" alt="Apply on LinkedIn" />
              </span>
            </a>
          </Col>
        </Row>

        {/* Job 5 */}
        <Row className="jobs mt-4">
          <Col lg={4}>
            <p className="posted-date">
              <img src="images/calendar.svg" alt="Diversity and Inclusion" />
              <span>Job Posted on June 27, 2026</span>
            </p>
            <h3>Software Developers/Fullstack Developer – Multiple Openings - Schaumburg, IL</h3>
          </Col>
          <Col lg={4} className="pt-30">
            <p>
              <img src="images/time.svg" alt="Full Time" />
              <span>Full Time</span>
            </p>
            <p>
              <img src="images/location.svg" alt="Full Time" />
              <span>Schaumburg, IL</span>
            </p>
          </Col>
          <Col lg={4} className="pt-20">
            <p className="posted-date text-end">
              <img
                style={{ position: "relative", left: "-6px" }}
                className="mr-1"
                src="images/calendar.svg"
                alt="Diversity and Inclusion"
              />
              <span className="ml-1">Job Closed on July 30, 2026</span>
            </p>
            <a href="javascript:void(0)" onClick={() => handleShow(5)}>
              View More
              <span>
                <img src="images/theme-arrow.svg" alt="Apply on LinkedIn" />
              </span>
            </a>
          </Col>
        </Row>
      </Container>

      {/* Dialogs */}
      <Modal
        show={activeModal === 1}
        onHide={handleClose}
        centered
        size="lg"
        className="job-modal"
      >
        <Modal.Header closeButton>
          <Modal.Title>
            Software Developers/SAP Developer– Multiple Openings
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="d-flex align-items-center justify-content-between mb-3">
            <h5>Job Posted On May 5, 2025</h5>
            <h5>Job Closed On May 25, 2025</h5>
          </div>

          <h3>Volto Consulting and Services LLC needs professionals:</h3>
          <p>
            Work using ABAP, Groovy Scripting, POSTMAN, SOAP UI, Eclipse, HANA &
            SQL.
          </p>
          <h6>Requirements:</h6>
          <ul>
            <li>Bachelor’s degree plus 5 years of experience.</li>
            <li>Wages: $149,000 per year.</li>
            <li>Relocate to unanticipated sites as required.</li>
            <li>No international or national travel.</li>
            <li>
              Send resume to Ref:
              <span style={{ color: "#0072DB" }}>
                {" "}
                President, 1750 E Golf Road, Ste 224, Schaumburg, IL 60173.
              </span>
            </li>
          </ul>
        </Modal.Body>
        {/* <Modal.Footer>
          <Button variant="secondary" onClick={handleClose}>Close</Button>
          <Button variant="primary">Apply Now</Button>
        </Modal.Footer> */}
      </Modal>

      <Modal
        show={activeModal === 2}
        onHide={handleClose}
        centered
        size="lg"
        className="job-modal"
      >
        <Modal.Header closeButton>
          <Modal.Title>
            Computer Systems Analyst/Business System Analyst - Multiple Openings
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="d-flex align-items-center justify-content-between mb-3">
            <h5>Job Posted On May 5, 2025</h5>
            <h5>Job Closed On May 25, 2025</h5>
          </div>
          <h3>Volto Consulting and Services LLC needs professionals:</h3>
          <p>
            Work using JIRA, Confluence, AWS Cloud Ops, SQL, RTC, Agile,
            Waterfall, UML and IT project management.
          </p>
          <h6>Requirements:</h6>
          <ul>
            <li>Bachelor’s degree plus 5 years of experience.</li>
            <li>Wages: $127,000 per year.</li>
            <li>Relocate to unanticipated sites as required.</li>
            <li>No international or national travel.</li>
            <li>
              Send resume to Ref:{" "}
              <span style={{ color: "#0072DB" }}>
                President, 1750 E Golf Road, Ste 224, Schaumburg, IL 60173.
              </span>
            </li>
          </ul>
        </Modal.Body>
      </Modal>

      <Modal
        show={activeModal === 3}
        onHide={handleClose}
        centered
        size="lg"
        className="job-modal"
      >
        <Modal.Header closeButton>
          <Modal.Title>Software Developers– Multiple Openings</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="d-flex align-items-center justify-content-between mb-3">
            <h5>Job Posted On May 5, 2025</h5>
            <h5>Job Closed On May 25, 2025</h5>
          </div>
          <h3>Volto Consulting and Services LLC needs professionals:</h3>
          <p>
            Work Using Magic XPA 3, UniPaaS, Magic eDeveloper 9.4, Btrieve,
            Pervasive, Oracle8i, 9i, Informatica , AWS and Azure.
          </p>
          <h6>Requirements:</h6>
          <ul>
            <li>Bachelor’s degree plus 5 years of experience.</li>
            <li>Wages: $149,000 per year.</li>
            <li>Relocate to unanticipated sites as required.</li>
            <li>No international or national travel.</li>
            <li>
              Send resume to Ref:{" "}
              <span style={{ color: "#0072DB" }}>
                President, 1750 E Golf Road, Ste 224, Schaumburg, IL 60173.
              </span>
            </li>
          </ul>
        </Modal.Body>
      </Modal>


       <Modal
        show={activeModal === 1}
        onHide={handleClose}
        centered
        size="lg"
        className="job-modal"
      >
        <Modal.Header closeButton>
          <Modal.Title>
           Software Developers– Multiple Openings - Schaumburg, IL
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="d-flex align-items-center justify-content-between mb-3">
            <h5>Job Posted On May 5, 2025</h5>
            <h5>Job Closed On May 25, 2025</h5>
          </div>

          <h3>Volto Consulting and Services LLC needs professionals:</h3>
          <p>
           Work on Java, ASP.Net, Python, Java Script, SQL, Unix, XML, JQuery, Web Services, MVC.

          </p>
          <h6>Requirements:</h6>
<ul>
  <li>Bachelor’s degree plus 5 years of experience, or Master’s degree plus 1 year of experience.</li>
  <li>Wages: $148,949 per year.</li>
  <li>Benefits include Health Insurance, Paid Time Off, Employee Assistance Program (EAP), referral incentives, and flexible work options for eligible employees.</li>
  <li>Relocate to unanticipated sites as required.</li>
  <li>No international or national travel.</li>
  <li>
    Send resume to Ref:
    <span style={{ color: "#0072DB" }}>
      {" "}
      President, 1750 E Golf Road, Ste 1080, Schaumburg, IL 60173.
    </span>
  </li>
</ul>

        </Modal.Body>
        {/* <Modal.Footer>
          <Button variant="secondary" onClick={handleClose}>Close</Button>
          <Button variant="primary">Apply Now</Button>
        </Modal.Footer> */}
      </Modal>

      {/* Modal 4: Computer Systems Analysts */}
      <Modal
        show={activeModal === 4}
        onHide={handleClose}
        centered
        size="lg"
        className="job-modal"
      >
        <Modal.Header closeButton>
          <Modal.Title>
            Computer Systems Analysts – Multiple Openings - Schaumburg, IL
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="d-flex align-items-center justify-content-between mb-3">
            <h5>Job Posted On June 27, 2026</h5>
            {/* <h5>Job Closed On November 7, 2026</h5> */}
          </div>

          <h3>Volto Consulting and Services LLC needs professionals:</h3>
          <p>
            Requires skills in CPQ, CLM, business analysis, UAT, and data analysis.
          </p>
          <h6>Requirements:</h6>
          <ul>
            <li>Bachelor’s degree +5 years of experience.</li>
            <li>Wages: $117,957 per year.</li>
            <li>
              Benefits: Health insurance, Paid time off, EAP, referral incentives & flexi work for eligible employees.
            </li>
            <li>Relocate to unanticipated sites.</li>
            <li>No international or national travel.</li>
            <li>
              Send mail to: Ref:
              <span style={{ color: "#0072DB" }}>
                {" "}
                President, 1750 E Golf Road, Ste 224, Schaumburg, IL 60173.
              </span>
            </li>
          </ul>
        </Modal.Body>
      </Modal>

      {/* Modal 5: Software Developers/Fullstack Developer */}
      <Modal
        show={activeModal === 5}
        onHide={handleClose}
        centered
        size="lg"
        className="job-modal"
      >
        <Modal.Header closeButton>
          <Modal.Title>
            Software Developers/Fullstack Developer – Multiple Openings - Schaumburg, IL
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="d-flex align-items-center justify-content-between mb-3">
            <h5>Job Posted On June 27, 2026</h5>
            <h5>Job Closed On July 30, 2026</h5>
          </div>

          <h3>Volto Consulting and Services LLC needs professionals:</h3>
          <p>
            Develop secure web applications with Java, React, APIs, and cloud services.
          </p>
          <h6>Requirements:</h6>
          <ul>
            <li>Master’s degree +1 year of experience.</li>
            <li>Wages: $130,707 per year.</li>
            <li>
              Benefits: Health insurance, Paid time off, EAP, referral incentives & flexi work for eligible employees.
            </li>
            <li>Relocate to unanticipated sites.</li>
            <li>No international or national travel.</li>
            <li>
              Send mail to: Ref:
              <span style={{ color: "#0072DB" }}>
                {" "}
                President, 1750 E Golf Road, Ste 224, Schaumburg, IL 60173.
              </span>
            </li>
          </ul>
        </Modal.Body>
      </Modal>
    </div>
  );
};

export default TempCareerCard;
